const emailSuccessMessage = document.querySelector(".email_success_message");
const emailErrorMessage = document.querySelector(".email_error_message");
const SHOPIFY_STOREFRONT_TOKEN = document.getElementById('customer-email').dataset.token;
const SHOPIFY_STOREFRONT_GRAPHQL = `https://${window.location.hostname}/api/2023-07/graphql.json`;

export async function updateEmail() {
    const newEmail = document.getElementById('new_email').value;
    const accessToken = window.localStorage.getItem("ShopifyCustomerToken");
    
    if (!accessToken) {
      console.error('Customer access token is missing');
      return;
    }
    
    const mutation = `
      mutation customerUpdate($customerAccessToken: String!, $customer: CustomerUpdateInput!) {
        customerUpdate(customerAccessToken: $customerAccessToken, customer: $customer) {
          customer {
            id
            email
          }
          customerUserErrors {
            code
            field
            message
          }
        }
      }
    `;
    
    const response = await fetch(`${SHOPIFY_STOREFRONT_GRAPHQL}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': SHOPIFY_STOREFRONT_TOKEN,
      },
      body: JSON.stringify({
        query: mutation,
        variables: {
          customerAccessToken: accessToken,
          customer: {
            email: newEmail,
          },
        },
      }),
    });
    
    const data = await response.json();
    if (data.errors || data.data.customerUpdate.customerUserErrors.length) {
        emailSuccessMessage.classList.remove("active");
        emailErrorMessage.classList.add("active");
        if (data.data.customerUpdate.customerUserErrors.length) {
            emailErrorMessage.textContent = data.data.customerUpdate?.customerUserErrors[0]?.message;
        }
    } else {
        emailErrorMessage.classList.remove("active");
        emailSuccessMessage.classList.add("active");
    }
}